export enum RegistrationType{
    MEMBER_REGISTRATION = 'MEMBER_REGISTRATION',
    CLUB_REGISTRATION = 'CLUB_REGISTRATION', 
}